<template>
    <div class="DM_subordinateMoney">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                      <el-select size v-model="searchForm.team_type" clearable placeholder="请选择活动类型">
                        <el-option label="货款分期回款" value="1"></el-option>
                        <el-option label="伪激活风控回款" value="2"></el-option>
                        <el-option label="未激活风控回款" value="3"></el-option>
                      </el-select>
                </el-form-item>
                <el-form-item>
                      <el-input clearable v-model="searchForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="searchForm.phone" placeholder="请输入归属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(searchForm)"
                    >查询</el-button>
                    <el-button
                            size="small"
                            type="primary"
                            icon="el-icon-download"
                            :loading="downLoading"
                            @click="handleDownLoad()"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="backList"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    max-height="1000px"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        type="index"
                        label="ID"
                        min-width="40"
                        key = '0'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="科目"
                        prop="subject"
                        min-width="180"
                        key = '1'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="来源"
                        prop="source"
                        min-width="330"
                        key = '2'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="金额(元)"
                        prop="money"
                        min-width="210"
                        key = '3'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="入账类型"
                        prop="type"
                        min-width="210"
                        key = '4'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="账户类型"
                        prop="card_type"
                        min-width="210"
                        key = '5'
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="入账时间"
                        prop="time"
                        min-width="210"
                        key = '6'
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10,20,50,100]"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <back-info v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></back-info>
    </div>
</template>

<script>

export default {
    name: "DM_riskControlList",
    data() {
        return {
            tableTitle: {
                my_money: 0,
                total_money: 0,
                total: 0,
            },
            detail: { //详情
                isShow: false,
                info: {}
            },
            brandList: [],
            searchForm: {
                page: 1,
                limit: 10,
                brand_id: '', //终端类型
                terminal_sn: '', //sn
                phone: '', //归属人账号
                start_time: '',
                end_time: '',
                team_type:'',
            },
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            backList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$$message.success(res.msg);
            }
        });
        this.getData({
            page: 1,
            limit: 10,
            type: 1,
        })
    },
    methods: {
        typeChange(val) { //监听radio
            this.searchForm.type = val;
            this.currentPage = 1; //重置分页
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData();
        },
        handleInfo(row) { //详情
            this.detail.isShow = true;
            this.detail.info = row;
        },
        infoClose() {
            this.detail.isShow = false;
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData();
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData();
        },
        getData() { //获取数据
            this.loading = true;
                this.$api.post("user_installment_repayment_log_main/subordinateMoney", this.searchForm, res => {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.backList = res.data.list;
                    //渲染结束后取消加载
                    this.loading = false;
                })
        },
        handleDownLoad() { //导出
            this.downLoading = true;
            this.$api.post("user_installment_repayment_log_main/subordinateMoneyDownload", this.searchForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    var link=this.$file_url+res.data;
                    window.open(link)
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.downLoading = false;
            })
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
    }
};
</script>

<style lang="scss" scope>
.DM_cashBackList {
  .el-input__inner {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor .el-range-input,
  .el-date-editor .el-range-separator {
    font-size: 12px;
  }
  .el-popover__title {
    font-size: 12px;
    font-weight: 700;
  }
  .tableTitle {
    display: inline-block;
    margin-right: 20px;
  }
}
</style>
